import { modalNames } from "@modals/modalNames";

import { resetModals, updateModals } from "./actions";

const initialModalsState = {
  modalData: {},
};

modalNames.forEach(
  (modalName) => (initialModalsState[`isOpen${modalName}Modal`] = false),
);

export const modalsSlice = (set, gets) => ({
  ...initialModalsState,
});

export const modalsActions = (set, get) => ({
  [resetModals]: (props) => {
    set((state) => ({
      ...state,
      modals: {
        ...initialModalsState,
        ...props,
      },
    }));
  },
  [updateModals]: (props, data) => {
    set((state) => {
      const newState = {
        ...state,
        modals: {
          ...state.modals,
          ...props,
        },
      };

      // Handle modal data if provided
      if (data) {
        // Find which modal is being opened (if any)
        const openingModal = Object.keys(props).find(
          (key) =>
            key.startsWith("isOpen") &&
            key.endsWith("Modal") &&
            props[key] === true,
        );

        if (openingModal) {
          // Extract modal name from the key (remove 'isOpen' prefix and 'Modal' suffix)
          const modalName = openingModal
            .replace("isOpen", "")
            .replace("Modal", "");

          // Update modal data for this specific modal
          newState.modals.modalData = {
            ...state.modals.modalData,
            [modalName]: data,
          };
        }
      }

      // Clean up data for any modal being closed
      Object.keys(props).forEach((key) => {
        if (
          key.startsWith("isOpen") &&
          key.endsWith("Modal") &&
          props[key] === false
        ) {
          const modalName = key.replace("isOpen", "").replace("Modal", "");

          if (state.modals.modalData && state.modals.modalData[modalName]) {
            // Create a new modalData object without the closed modal's data
            const { [modalName]: _, ...remainingModalData } =
              newState.modals.modalData;
            newState.modals.modalData = remainingModalData;
          }
        }
      });

      return newState;
    });
  },
  // [updateModals]: (props) => {
  //   set(produce((state) => {
  //     state.modals.
  //   }));
  // },
});
